module.exports = __webpack_public_path__ + "static/media/complete-rate.cfa2af3d.svg";